import { __ } from '@wordpress/i18n';
import { Image } from 'lucide-react';
import { createMediaField } from './media-field';

declare module '@tiptap/core' {
	interface Commands<ReturnType> {
		image: {
			insertImage: (attrs?: { url?: string; title?: string }) => ReturnType;
		};
	}
}

export const ImageField = createMediaField({
	name: 'image',
	dataType: 'image',
	libraryType: 'image',
	addLabel: __('Add Image', 'allcoach'),
	subLabel: __('Click to select from media library', 'allcoach'),
	icon: Image,
	commandName: 'insertImage',
});
